<main [attr.data-theme]="darkModeEnabled() ? 'dark' : 'light'">
  @if (screenWidth() > 768 || hasResponsive) {
    <cb-page-loader [isLoading]="isLoadingPrivileges()">
      @if (isBackoffice) {
        <cb-layout [fillViewport]="true">
          @if (showSidebar()) {
            <cb-sidebar
              [navItems]="backofficeNavItems"
              [footerItems]="backofficeFooterItems"
              [logo]="logo()"
              [userId]="userId()"
              theme="brand"
              position="left"
              [restrictedUserOptions]="true"
              (logout)="logout()"
            ></cb-sidebar>
          }

          <cb-layout-col [style.flex]="1">
            <div class="cb-route">
              <router-outlet></router-outlet>
            </div>
          </cb-layout-col>
        </cb-layout>
      } @else {
        <cb-layout [fillViewport]="true">
          <!-- @if(showSidebar()){
            <cb-sidebar [compact]="true" [navItems]="sidebarNavItems" [footerItems]="sidebarFooterItems"
                logo="/assets/logo/pictogram.svg" [tenantName]="tenantName()" [userId]="userId()"
                [profileName]="authName()" [profileEmail]="authEmail()" theme="light" position="left"
                (logout)="logout()"></cb-sidebar>
            } -->

          <cb-layout-toolbar area="header" [fullWidth]="true">
            <cb-layout-item>
              @if (isDev) {
                <div class="cb-test-banner">
                  <p>{{ "COMMON.DEV_MODE" | translate }}</p>
                </div>
              }
            </cb-layout-item>
          </cb-layout-toolbar>

          @if (showSidebar()) {
            <cb-top-navbar
              [logo]="logo()"
              [homeRoute]="homeRoute()"
              [navItems]="sidebarNavItems()"
              [footerItems]="sidebarFooterItems()"
              [tenantName]="tenantName()"
              [userId]="userId()"
              [profileName]="authName()"
              [profileEmail]="authEmail()"
              theme="brand"
              position="left"
              (logout)="logout()"
              [background]="background()"
              [restrictedUserOptions]="hasRestrictedUserOptions()"
            ></cb-top-navbar>
          }

          <cb-layout-col [style.flex]="1">
            <div class="cb-route">
              <router-outlet></router-outlet>
            </div>
          </cb-layout-col>
        </cb-layout>
      }
    </cb-page-loader>
  } @else {
    <cb-layout [fillViewport]="true">
      <cb-layout-col [style.flex]="1">
        <cb-empty-state
          [title]="'COMMON.RESPONSIVE.ERROR.TITLE' | translate"
          [subtitle]="'COMMON.RESPONSIVE.ERROR.SUBTITLE' | translate"
        ></cb-empty-state>
      </cb-layout-col>
    </cb-layout>
  }
</main>

<cb-choice-widget></cb-choice-widget>

<ng-template #notificationPopover>
  <cb-notification-popover></cb-notification-popover>
</ng-template>
